import { brandStats, faqItems } from '@/mocks/data';

export default function TrustSection() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            为什么选择皇冠体育
          </h2>
          <p className="text-sm text-foreground-500 mt-2">15年品牌信誉 · 500万用户信赖之选</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mb-14">
          {brandStats.map((stat, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center"
            >
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                <i className={`${stat.icon} text-lg text-accent-700`}></i>
              </div>
              <p className="text-2xl font-bold text-foreground-900 mb-1">{stat.value}</p>
              <p className="text-xs text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto">
          <h3 className="text-lg font-heading font-bold text-foreground-900 text-center mb-6">
            常见问题
          </h3>
          <div className="space-y-3">
            {faqItems.map((item, index) => (
              <details
                key={index}
                className="bg-background-50 border border-background-200/70 rounded-lg group cursor-pointer"
              >
                <summary className="px-5 py-4 text-sm font-medium text-foreground-900 flex items-center justify-between gap-3">
                  {item.question}
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform text-sm"></i>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}